document.addEventListener('DOMContentLoaded', function () {
  setupEmailValidation({
    inputId: 'CustomerEmail',
    errorId: 'CustomerEmailError',
    formId: 'customer_login',
    loadingFallback: 'Accesso in corso...'
  });

  setupEmailValidation({
    inputId: 'RecoverEmail',
    errorId: 'RecoverEmailError',
    formId: 'recover_customer_password',
    loadingFallback: 'Invio in corso...'
  });

  setupFormToggle();
});

// Reset loading state when page is restored from bfcache (browser back/forward).
// Without this, the submit button stays disabled after navigating back to the login page.
window.addEventListener('pageshow', function (event) {
  if (!event.persisted) return;
  document.querySelectorAll('button.form__send__button[aria-busy="true"]').forEach(function (btn) {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    var defaultText = btn.dataset.textDefault;
    if (defaultText) btn.textContent = defaultText;
  });
});

function setupFormToggle() {
  const recoverForm = document.getElementById('recover');
  if (!recoverForm) return;

  // Mostra il form recover se l'URL contiene #recover al caricamento
  if (window.location.hash === '#recover') {
    recoverForm.classList.add('active');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }, 0);
  }

  document.querySelectorAll('a[href="#recover"], a[href="#login"]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const target = link.getAttribute('href');

      if (target === '#recover') {
        recoverForm.classList.add('active');
      } else {
        recoverForm.classList.remove('active');
      }

      window.scrollTo({ top: 0, behavior: 'instant' });
    });
  });
}

function setupEmailValidation({ inputId, errorId, formId, loadingFallback = 'Accesso in corso...' }) {
  const input = document.getElementById(inputId);
  if (!input) return;

  const formById = formId ? document.getElementById(formId) : null;
  const form = formById || input.closest('form');

  const error = document.getElementById(errorId);
  const submitButton = form ? form.querySelector('button.form__send__button') : null;

  if (!form || !error || !submitButton) return;

  const message = input.dataset.errorMessage || 'Invalid email';
  const textDefault = submitButton.dataset.textDefault || submitButton.textContent.trim();
  const textLoading = submitButton.dataset.textLoading || loadingFallback;
  const strictEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isEmailValid(value) {
    return strictEmailRegex.test((value || '').trim());
  }

  function showError() {
    error.textContent = message;
    input.setAttribute('aria-invalid', 'true');
  }

  function clearError() {
    error.textContent = '';
    input.removeAttribute('aria-invalid');
  }

  var loadingTimeout = null;

  function setLoadingState() {
    submitButton.disabled = true;
    submitButton.textContent = textLoading;
    submitButton.setAttribute('aria-busy', 'true');

    // Safety net: if the page hasn't navigated away within 8 s (e.g. a JS
    // error in Shopify's identity/new-accounts scripts prevents navigation),
    // reset the button so the user can try again.
    loadingTimeout = setTimeout(resetButton, 8000);

    // Cancel the timeout the moment the browser actually starts navigating
    // away — in that case the loading state should stay until the new page loads.
    window.addEventListener('pagehide', function onPageHide() {
      clearTimeout(loadingTimeout);
      window.removeEventListener('pagehide', onPageHide);
    });
  }

  function resetButton() {
    if (loadingTimeout) { clearTimeout(loadingTimeout); loadingTimeout = null; }
    submitButton.disabled = false;
    submitButton.textContent = textDefault;
    submitButton.removeAttribute('aria-busy');
  }

  input.addEventListener('input', function () {
    if (isEmailValid(input.value)) clearError();
  });

  form.addEventListener(
    'submit',
    function (e) {
      if (!isEmailValid(input.value)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showError();
        input.focus();
        resetButton();
        return false;
      }
      clearError();
      setLoadingState();
    },
    true
  );
}
